export const InfoVoiceBannerTranslations = {
  VOICE_BANNER_TITLE: {
    es: '¡Estudia con tu voz con Umy!',
    en: 'Study with your voice with Umy!',
    cat: 'Estudia amb la teva veu amb Umy!',
    eus: 'Ikasi zure ahotsarekin Umy-rekin!',
    pt: 'Estude com a sua voz com Umy!'
  },
  VOICE_BANNER_DESCRIPTION: {
    es: 'El nuevo modo de estudio por voz de Umy está disponible en tus actividades. Habla, pregunta y aprende de forma natural.',
    en: "Umy's new voice study mode is available in your activities. Speak, ask and learn naturally.",
    cat: "El nou mode d'estudi per veu d'Umy està disponible a les teves activitats. Parla, pregunta i aprèn de forma natural.",
    eus: 'Umy-ren ahots bidezko ikasketa modu berria zure jardueretan dago eskuragarri. Hitz egin, galdetu eta ikasi modu naturalean.',
    pt: 'O novo modo de estudo por voz do Umy está disponível nas suas atividades. Fale, pergunte e aprenda de forma natural.'
  },
  VOICE_BANNER_CTA: {
    es: 'Probar ahora',
    en: 'Try it now',
    cat: 'Prova-ho ara',
    eus: 'Probatu orain',
    pt: 'Experimentar agora'
  }
};
